import React, { FC, useEffect, useRef } from 'react';
import { ComponentRendering, isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { TCHSeriesDetailDownloadBrochuresProps } from './types/productSeriesDetailDownloadBrochures.types';
import { CHSeriesDetailDownloadBrochureModel } from './models/productSeriesDetailDownloadBrochures.model';
import BrochureCard from './components/brochureCard';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import TextComponentDecider from '../@shared/TextComponentDecider';
import { getTextType } from '../../utils/getTextType.utils';
import { descriptionKeySeriesBrochure, eyebrowKeySeriesBrochure, titleKeySeriesBrochure } from '../../constants/dictionary.constants';
import { addToAnyScript } from '../../utils/addToAnyScript.utils';

const ProductSeriesDetailDownloadBrochures: FC<TCHSeriesDetailDownloadBrochuresProps> = (props) => {
  const model = new CHSeriesDetailDownloadBrochureModel(props);
  const apiResponse = isEmptyResponse(props);
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setTimeout(() => {
      addToAnyScript();
    });
  }, [model.contextItemUrl]);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
  }

  if ((!apiResponse || !model.canShowComponent) && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  if ((!apiResponse && !isPlaceholderShown && !isEditorActive()) || !model.canShowComponent) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent
      rendering={props?.rendering as ComponentRendering}
      title={model?.title?.value ?? model?.eyebrow?.value ?? ''}
      template="Download Brochures"
    >
      <section>
        <div className="series-detail-download-brochure-container" style={{ backgroundColor: model.backgroundColor || '#fff' }}>
          <div className="series-detail-download-brochure-container__label-container">
            <TextComponentDecider
              type={getTextType('Text', !model?.eyebrow?.value)}
              tag={'p'}
              field={{ value: model?.eyebrow?.value }}
              className="series-detail-download-brochure-container__eyebrow"
              dictionaryKey={eyebrowKeySeriesBrochure}
            />
            <TextComponentDecider
              type={getTextType('Text', !model?.title?.value)}
              tag={'p'}
              field={{ value: model?.title?.value }}
              className="series-detail-download-brochure-container__title"
              dictionaryKey={titleKeySeriesBrochure}
            />
            <TextComponentDecider
              type={getTextType('RichText', !model?.description?.value)}
              tag={'div'}
              field={{ value: model?.description?.value }}
              className="series-detail-download-brochure-container__description rich-text"
              dictionaryKey={descriptionKeySeriesBrochure}
            />
          </div>
          <div className="series-detail-download-brochure-container__card-container">
            {model.downloadBrochureCard.map((card, index) => (
              <BrochureCard {...card} key={card.full} componentNumber={index + 1} />
            ))}
          </div>
        </div>
      </section>
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(ProductSeriesDetailDownloadBrochures);
